import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDebouncedEffect } from "util/useDebouncedEffect";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";

import storelogo from "assets/images/storelogo.png";
import Api from "api/Api";
import CommonModal from "components/common/CommonModal";
import StoreModal from "./StoreModal";
import Loader from "components/common/Loader";
import Toaster from "components/common/Toaster";
import StoreActions from "redux/storeID/actions";
import fileDownload from "js-file-download";
import moment from "moment";

const { setStoreId, resetStoreId } = StoreActions;

const StoreTable = props => {
  const [tblData, settblData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("DESC");
  const [field, setField] = useState("createdAt");
  const [viewModal, setviewModal] = useState(false);
  const [viewData, setviewData] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [isCsvLoading, setIsCsvLoading] = useState(false);
  const toaster = useRef();

  const { history, setStoreId, resetStoreId } = props;

  const formAction = useCallback(
    (action, data = null) => {
      // Here you can view the data and make forward action for edit data
      if (action === "add") {
        history.push("/store/add");
      } else if (action === "edit") {
        history.push(`/store/edit/${data.storeId}`, data);
      }
    },
    [history]
  );

  const columns = [
    {
      Header: "Store Logo",
      accessor: "storeLogo",
      className: "text-center",
      sortable: false,
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 100,
      resizable: false,
      Cell: props => (
        <div>
          <img
            src={
              props.original.storeLogo ? props.original.storeLogo : storelogo
            }
            alt=""
            style={{
              height: 56,
              width: 56,
              borderRadius: "50%",
              objectFit: "cover"
            }}
          />
        </div>
      )
    },
    {
      Header: "Store Name",
      accessor: "storeName",
      className: "text-center",
      filterable: false,
      width: 200,
      resizable: false,
      headerClassName: "react-table-header-class",
      Cell: props => (
        <span
          title={props.value}
          className="gt-store-table-text"
          style={{
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 188,
            margin: "0 auto"
          }}
        >
          {props.value}
        </span>
      )
    },
    {
      Header: "Store Code",
      accessor: "storeCode",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 175,
      resizable: false,
      Cell: props => (
        <div className="react-action-class">
          {props.original?.storeCode ? (
            <Button
              className="c-btn c-info gt-store-table-btn"
              onClick={() => {
                navigator.clipboard.writeText(props.original.storeCode);
                if (toaster.current)
                  toaster.current.success("Store Code copied!");
              }}
            >
              <i className="fas fa-copy mr-6" />
              {props.original.storeCode}
            </Button>
          ) : (
            <span className="gt-store-table-text text-muted">-</span>
          )}
        </div>
      )
    },

    {
      Header: "Action",
      accessor: "action",
      className: "text-center gt-action-cell",
      headerClassName: "react-table-header-class gt-action-cell",
      sortable: false,
      filterable: false,
      width: 760,
      minWidth: 760,
      resizable: false,
      Cell: cellProps => {
        const row = cellProps.original;
        return (
          <div className="gt-action-row">
            <Button
              className="c-btn c-info gt-store-table-btn"
              onClick={() => {
                setStoreId({
                  id: row.storeId,
                  name: row.storeName,
                  storeLoyaltyPartner: row.storeLoyaltyPartner
                });
                history.push("/store/dashboard");
              }}
            >
              <i className="fas fa-chart-line mr-6" /> Dashboard
            </Button>
            <Button
              className="c-btn c-info gt-store-table-btn"
              onClick={() => viewHandler(row)}
            >
              <i className="fas fa-info mr-6" /> View
            </Button>
            <Button
              className="c-btn c-info gt-store-table-btn"
              onClick={() => history.push(`/receipt-page/${row.storeId}`)}
            >
              <i className="fas fa-qrcode mr-6" /> Receipt
            </Button>
            <Button
              className="c-btn c-success gt-store-table-btn"
              onClick={() => formAction("edit", row)}
            >
              <i className="fas fa-edit mr-6" /> Edit
            </Button>
            <Button
              className="c-btn c-danger gt-store-table-btn"
              onClick={() => {
                setToggle(!toggle);
                setdeleteId(row.storeId);
              }}
            >
              <i className="fas fa-trash mr-6" /> Delete
            </Button>
          </div>
        );
      }
    }
  ];

  useDebouncedEffect(() => {
    setLoader(true);
    setActivePage(0);
    callListApi({
      page: {
        limit: 10,
        pageId: 1
      },
      search: searchText,
      sortBy: {
        direction: sortBy,
        property: field
      }
    });
  }, [searchText]);

  useEffect(() => {
    const params = {
      page: {
        limit: 10,
        pageId: 1
      },
      sortBy: {
        direction: "DESC",
        property: "createdAt"
      },
      search: ""
    };
    callListApi(params);
    setPages(10);
  }, []);

  const callListApi = params => {
    setLoader(true);
    Api.post("/admin/store/list", params)
      .then(res => {
        settblData(res.data.data.list);
        setLoader(false);
        setPages(Math.ceil(res.data.data.totalRecords / 10));
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.message);
        setLoader(false);
      });
  };

  const viewHandler = data => {
    setviewData(data);
    setviewModal(true);
  };

  const handleYes = () => {
    setLoading(true);
    Api.delete(`/admin/store/delete?storeId=${deleteId}`)
      .then(res => {
        if (toaster.current) toaster.current.success(res.data.message);
        callListApi({
          page: {
            limit: 10,
            pageId: activePage + 1
          },
          search: searchText,
          sortBy: {
            direction: sortBy,
            property: field
          }
        });
        setLoading(false);
        setToggle(!toggle);
      })
      .catch(error => {
        setLoading(false);
        setToggle(!toggle);
        if (toaster.current) toaster.current.error(error);
      });
  };

  const downloadCSV = async () => {
    setIsCsvLoading(true);
    const response = await Api.get("/admin/store/exportCSV");
    const fileName = `stores-${moment().format("MM-DD-YYYY")}.csv`;

    if (response) {
      fileDownload(response.data, fileName);
    }
    if (response.status === 200) {
      toaster.current.success("CSV file downloaded");
    }
    setIsCsvLoading(false);
  };

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Store List
            </div>
            <div className="mr-10">
              <input
                value={searchText}
                onChange={e => {
                  setActivePage(0);
                  setSearchText(e.target.value);
                }}
                type="text"
                placeholder="Search..."
                className="fs-14 medium-text plr-10 form-control react-form-input"
              />
            </div>
            <div>
              <Button
                className="c-btn ma-5"
                onClick={() => formAction("add")}
                style={{
                  backgroundColor: "#0f172a",
                  color: "#fff"
                }}
              >
                <i className="fas fa-plus mr-10"></i>Add Store
              </Button>
              <Button
                className="c-btn ma-5"
                onClick={downloadCSV}
                style={{
                  backgroundColor: "#0f172a",
                  color: "#fff"
                }}
                disabled={isCsvLoading}
              >
                {!isCsvLoading ? (
                  <i class="fas fa-file-csv"></i>
                ) : (
                  <i class="fas fa-ellipsis-h"></i>
                )}
              </Button>
            </div>
          </div>
          <div className="roe-card-body gt-table-scroll gt-table-scroll--store">
            <ReactTable
              style={{
                border: "none",
                boxShadow: "none",
                width: 1235
              }}
              // ref={tableRef}
              data={tblData}
              columns={columns}
              defaultPageSize={10}
              filterable
              minRows={2}
              manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;

                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(
                      filter.value.toLowerCase()
                    )
                  : true;
              }}
              getTdProps={(state, rowInfo, column) => {
                if (column.id === "action") {
                  return {
                    style: {
                      overflow: "visible",
                      height: 88,
                      whiteSpace: "nowrap"
                    }
                  };
                }
                return { style: { height: 88 } };
              }}
              getTrProps={() => ({
                style: { height: 88 }
              })}
              className="-striped -highlight custom-react-table-theme-class gt-store-table"
              pages={pages}
              page={activePage}
              PaginationComponent={Pagination}
              loading={loader}
              LoadingComponent={Loader}
              onPageChange={pageIndex => {
                setActivePage(pageIndex);
                callListApi({
                  page: {
                    limit: 10,
                    pageId: pageIndex + 1
                  },
                  search: searchText,
                  sortBy: {
                    direction: sortBy,
                    property: field
                  }
                });
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setSortBy(sort);
                setActivePage(0);
                setField(sortProperties[0].id);
                callListApi({
                  page: {
                    limit: 10,
                    pageId: activePage + 1
                  },
                  search: searchText,
                  sortBy: {
                    direction: sort,
                    property: sortProperties[0].id
                  }
                });
              }}
            />
          </div>
          <Toaster ref={toaster} />
          <CommonModal
            size="lg"
            modal={viewModal}
            toggle={() => {
              setviewModal(!viewModal);
            }}
            viewModalCheck={true}
            headerData={"Store Details"}
            children={<StoreModal data={viewData} />}
          />
          <CommonModal modal={toggle}>
            <div className="react-table-header-class text-center ptb-18">
              Are you sure you want to delete?
            </div>
            <div className="text-center pb-15">
              <Button
                className="c-btn c-success mr-10 plr-30"
                onClick={handleYes}
                loading={loading}
                disabled={loading}
                dataStyle="expand-right"
              >
                Yes
              </Button>
              <Button
                className="c-btn c-danger plr-30"
                onClick={() => {
                  setToggle(!toggle);
                }}
              >
                No
              </Button>
            </div>
          </CommonModal>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.storeID
  };
};

export default compose(
  connect(mapStateToProps, { setStoreId, resetStoreId }),
  withRouter
)(StoreTable);
